var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nandu-trend"},[_c('div',{ref:"chart",staticClass:"nandu-trend__canvas",attrs:{"role":"img","aria-label":_vm.summary}}),_c('ol',{staticClass:"nandu-visually-hidden"},_vm._l((_vm.points),function(point){return _c('li',{key:point.date},[_vm._v(_vm._s(point.date)+"："+_vm._s(point.value)+" 千瓦时")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }